import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ENUMS from '../../../enums/index';
import { formatter, enumHelper } from '../../../utils';
import * as paymentsActions from '../../../redux/payments/actions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../components/loading';
import './paymentDetail.scss';

const PaymentDetails = props => {
  let {
    userFullName,
    userMobileNumber,
    trackingNumber,
    bankPortalName = 'EGHTESAD_NOVIN',
    status = 'PENDING',
    amount,
    currency = 'TOMAN',
    bankReferenceNumber,
    bankTracingNumber,
    description,
    createdAt,
    paidAt,
    bankResponse,
  } = props.paymentDetails;

  let { loading, error, failed, message } = props;
  useEffect(() => {
    props.fetchPaymentDetails(props.paymentId);
  }, []);
  return (
    <>
      <Modal id='financial-transaction-modal' size='xl' isOpen={props.isOpen}>
        <ModalHeader>
          <div className='row'>
            <div className='col-11'>
              {locales('titles.financial.transaction.details')}
            </div>
            <div className='col-1 text-left'>
              <a
                href='#'
                className=''
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className='fas fa-times'></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={loading}>
            <article>
              {error ? (
                <div className='alert alert-danger'>
                  {locales('messages.server.error')}
                </div>
              ) : (
                <>
                  {failed && (
                    <div className='alert alert-danger'>{message}</div>
                  )}
                  <article className='col-12'>
                    <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                      {locales('titles.userDetails')}
                    </div>
                    <div className='col-12 d-flex border rounded py-2 px-1'>
                      <div className='col-6 d-flex align-items-center'>
                        <div className='col-5 text-muted'>
                          {locales('tables.fullName')} :{' '}
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {userFullName}
                        </div>
                      </div>
                      <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                        <div className='col-5 text-muted text-left'>
                          {locales('fields.mobileNumber')} :{' '}
                        </div>
                        <div className='col-7 text-left text-dark font-weight-bold font-large'>
                          {userMobileNumber}
                        </div>
                      </div>
                    </div>

                    <div className='my-4'>
                      <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                        {locales('titles.paymentInfo')}
                      </div>
                      <div className='col-12 d-flex border rounded py-2 px-1 flex-wrap'>
                        <div className='col-12 d-flex align-items-center'>
                          <div className='col-2 text-muted'>
                            {locales('tables.bankName')} :{' '}
                          </div>
                          <div className='col-9 mx-5  p-0 text-dark font-weight-bold font-large'>
                            {enumHelper.convertEnumValueToTitle(
                              ENUMS.BANK_NAMES.list,
                              bankPortalName,
                            )}
                          </div>
                        </div>

                        <div className='col-6 d-flex align-items-center'>
                          <div className='col-5 text-muted'>
                            {locales('tables.trackingCode')} :{' '}
                          </div>
                          <div className='col-7 text-dark font-weight-bold font-large direction-ltr'>
                            {trackingNumber || '---'}
                          </div>
                        </div>
                        <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                          <div className='col-5 text-muted text-left'>
                            {locales('fields.requestTime')} :{' '}
                          </div>
                          <div className='col-7 text-left text-dark font-weight-bold font-large'>
                            {createdAt}
                          </div>
                        </div>

                        <div className='col-6 d-flex align-items-center'>
                          <div className='col-5 text-muted'>
                            {locales('tables.bankRefrenceNumber')} :{' '}
                          </div>
                          <div className='col-7 text-dark font-weight-bold font-large'>
                            {bankReferenceNumber || '---'}
                          </div>
                        </div>
                        <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                          <div className='col-5 text-muted text-left'>
                            {locales('tables.payTime')} :{' '}
                          </div>
                          <div className='col-7 text-left text-dark font-weight-bold font-large'>
                            {paidAt}
                          </div>
                        </div>

                        <div className='col-6 d-flex align-items-center'>
                          <div className='col-5 text-muted'>
                            {locales('tables.bankTrackingNumber')} :{' '}
                          </div>
                          <div className='col-7 text-dark font-weight-bold font-large'>
                            {bankTracingNumber || '---'}
                          </div>
                        </div>
                        <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                          <div className='col-5 text-muted text-left'>
                            {locales('tables.payStatus')} :{' '}
                          </div>
                          <div className='col-7 text-left text-dark font-weight-bold font-large'>
                            {enumHelper.convertEnumValueToTitle(
                              ENUMS.BANK_STATUS.list,
                              status,
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='my-4'>
                      <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                        {locales('tables.bankOtherInfo')}
                      </div>
                      <div
                        className={`mb-4 border border-1 rounded ${
                          bankResponse && Object.keys(bankResponse).length > 0
                            ? ''
                            : 'd-none'
                        }`}
                      >
                        <div className='col-12'>
                          <pre>{JSON.stringify(bankResponse, null, '  ')}</pre>
                        </div>
                      </div>
                    </div>

                    <div className='my-4'>
                      <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                        {locales('titles.systemDescription')}
                      </div>
                      <div className='col-12 d-flex border rounded py-2 px-1'>
                        {description}
                      </div>
                    </div>

                    <div className='my-4 col-12 d-flex p-0 justify-content-end align-items-center'>
                      <div className='border rounded p-2'>
                        <span> {locales('tables.paidPrice')} :</span>
                        <span className='font-weight-bold text-dark px-2'>
                          {`${formatter.numberWithCommas(amount)} ${locales(
                            `tables.${currency.toLowerCase()}`,
                          )}`}
                        </span>
                      </div>
                    </div>
                  </article>
                </>
              )}
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-light' onClick={() => props.closeModal()}>
            {locales('labels.close.modal')}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};
const mapStateToProps = state => {
  return {
    paymentDetails: state.paymentsReducer.paymentDetails || {},
    loading: state.paymentsReducer.paymentDetailsLoading,
    message: state.paymentsReducer.paymentDetailsMessage,
    failed: state.paymentsReducer.paymentDetailsFailed,
    error: state.paymentsReducer.paymentDetailsError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchPaymentDetails: id =>
      dispatch(paymentsActions.fetchPaymentDetails(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetails);
